import { queriesPayrollRuns } from "@query";
import { PayrollRunExpand } from "@wingspanhq/wingspan-api-sdk";

/**
 * Run-level rollups (gross, payer taxes, pay-statement count) for one run.
 *
 * `listPayrollRuns` accepts no `expand`, so the list response carries no
 * breakdown. Rather than an aggregation hook over the whole page, each card/cell
 * fetches its own run at the point of use — the request shape matches the one
 * `RoutePayrollRunsDetails` issues, so opening a run reuses the cached read.
 */
export const useQueryPayrollRunBreakdown = (payrollRunId: string) =>
  queriesPayrollRuns.getPayrollRun.useQuery(
    { payrollRunId, expand: [PayrollRunExpand.BREAKDOWN] },
    { enabled: !!payrollRunId }
  );
